import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      className="px-6 py-3 shrink-0"
      style={{ backgroundColor: '#0a0b16', borderTop: '1px solid rgba(255,255,255,0.05)' }}
    >
      <p className="text-[11px] text-zinc-700">Derechos reservados © {year} Agents</p>
    </footer>
  );
};

export default Footer;
